import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '../config/firebase';
import { useLanguage } from '../contexts/LanguageContext';

const CmbRates = () => {
  const { t, language } = useLanguage();
  const [rate, setRate] = useState(undefined);
  const [asOfDate, setAsOfDate] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ref = doc(firestore, 'marketRates', 'cmb');
    const unsub = onSnapshot(
      ref,
      (snap) => {
        setLoading(false);
        setError(false);
        if (!snap.exists()) {
          setRate(undefined);
          setAsOfDate(null);
          return;
        }
        const data = snap.data() || {};
        const value = Number(data.fiveYearNextCmb);
        setRate(Number.isFinite(value) ? value : undefined);
        setAsOfDate(typeof data.asOfDate === 'string' ? data.asOfDate : null);
      },
      (err) => {
        console.error('Failed to subscribe to CMB rates', err);
        setLoading(false);
        setError(true);
      }
    );
    return () => unsub();
  }, []);

  const formatRate = (value) =>
    value !== undefined ? parseFloat(value).toFixed(2) : 'N/A';

  const formatAsOfDate = (iso) => {
    if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return null;
    const [y, m, d] = iso.split('-').map(Number);
    const date = new Date(y, m - 1, d);
    try {
      return new Intl.DateTimeFormat(language === 'fr' ? 'fr-CA' : 'en-CA', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }).format(date);
    } catch (_) {
      return iso;
    }
  };

  if (error) {
    return (
      <div className="text-center text-sm text-red-500 mt-2">
        {t('home.cmb.error')}
      </div>
    );
  }

  if (loading) {
    return (
      <div className="text-center text-sm text-gray-500 mt-2">
        {t('loading')}
      </div>
    );
  }

  if (rate === undefined) {
    return (
      <div className="text-center text-sm text-gray-500 mt-2">
        {t('home.cmb.empty')}
      </div>
    );
  }

  const dateLabel = formatAsOfDate(asOfDate);

  return (
    <div className="text-center text-sm text-gray-500 mt-2 px-1">
      <h3 className="font-medium">
        {dateLabel ? `${t('home.cmb.title')} (${dateLabel})` : t('home.cmb.title')}
      </h3>
      <p className="break-words leading-relaxed">
        {formatRate(rate)}%
      </p>
    </div>
  );
};

export default CmbRates;
